import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import './rag-cell.component.scss';

export interface RagCellBehavior<T> {
    redFn?: (item: T) => boolean;
    amberFn?: (item: T) => boolean;
    greenFn?: (item: T) => boolean;
    grayFn?: (item: T) => boolean;
    noneFn?: (item: T) => boolean;
    blueFn?: (item: T) => boolean;
}

@Component({
    selector: 'rag-cell',
    template: require('./rag-cell.component.html'),
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class RagCellComponent<T> {
    @Input() behavior: RagCellBehavior<T>;
    @Input() item: T;
    @Input() displayData: any;
}
